<template>
  <page-template >
    <template slot="page-content">
      <div class="generic--template page-template pb5 bg-beige">
         <!-- CONTENT -->
        <div class="relative z-content">
          <div class="relative container-fluid mw8-5 center">
            <div class="row mt3 mt4-ns">
              <div class="dn db-ns col-xs-12 col-sm-6">
                <div class="db relative aspect-ratio--16x9 bg-teal center cover" v-lazy:background="page.hero_image"></div>
              </div>
              <div class="col-xs-12 col-sm-6">
                <div class="db relative aspect-ratio--16x9 bg-teal">
                  <img class="db absolute abs-vert-center left-0 right-0 center mw-24rem" v-lazy="page.logo" title="Outside Lands Works" />
                  <!-- <router-link class="db absolute abs-vert-center left-0 right-0 center mt6 w-100 mw5 btn-generic has-red-bg" to="/outside-lands-works/donate/"><span class="text">Donate</span></router-link>-->
                </div>
              </div>
              <div class="db dn-ns col-xs-12 col-sm-6">
                <div class="db relative aspect-ratio--16x9 bg-teal center cover" v-lazy:background="page.hero_image"></div>
              </div>
            </div>
          </div>
          <section class="relative">
            <div class="relative container-fluid mw8-5 center">
              <div class="row center">
                <div class="col-xs-12 col-sm-12 mt4 mt5-ns">
                  <div class="row" v-if="page.intro_text">
                    <div class="col-xs-12 col-sm-12 pb3">
                      <h3 class="f2 mb4 tl is-tablet-bold is-teal">About Outside Lands Works</h3>
                      <div class="f4 is-tablet-regular link-bold lh-copy cms-content" v-html="marked(page.intro_text)"></div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-12 pb5">
                      <h2 class="f2 pb4 mb3 is-tablet-bold is-teal">{{ page.grantees_section.title }}</h2>
                      <div class="row">
                        <a v-for="(grantee, index) in page.grantees_section.grantees" class="col-xs-12 col-sm-6 mb3" :href="grantee.link" target="_blank" :title="grantee.title" :key="'grantee-item-' + index">
                          <div class="flex flex-row items-center">
                            <img class="db relative center mw4" :src="grantee.image" :title="grantee.title" />
                            <div class="f4 mv3 pl3 lh-copy is-black" v-html="grantee.text">
                              <div class="" v-html="grantee.text"></div>
                              <span class="mt3 ttu is-black">Learn More</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section id="ol-works" class="db relative center mw8 pt5 pt6-ns">
            <div class="plg-donate" data-widget-id="xsZJ7T2BtWPZdsf0VZa1tg"></div>
          </section>
        </div>
      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from './page-template.vue';
// import SignupForm from './signup-form.vue';
import BgVimeoVideo from './bg-vimeo-video.vue';
export default {
  components: {
    PageTemplate,
    // SignupForm,
    BgVimeoVideo
  },
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk} | ` + this.$site_seo_title_suffix : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      parallax:null,
      parallax2:true,
      window: {
        width: 0,
        height: 0
      },
      isWindowWidthMobile: null,
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName(this.pageMarkdownFileName);
      return pageData[0];
    }
  },
  methods : {
    sizing: function(){
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 768)
        this.isWindowWidthMobile = true; 
      else{
        this.isWindowWidthMobile = false; 
        this.mobileActive = -1;
      }
      this.scrollBg();
      if(this.swiper)
        this.swiper.update();
    },
    scrollParallax: function(){
      this.parallax = window.scrollY;
    }
  },
  created() {
    var w = window.innerWidth;
    if (w < 768) {
      this.isWindowWidthMobile = true; 
    }
    else {
      this.isWindowWidthMobile = false; 
    }
    window.addEventListener('resize', this.sizing);
    window.addEventListener('scroll', this.scrollBg);
    window.addEventListener('load', this.sizing);
  },
  beforeMount() {
    //
  },
  mounted() {
    setInterval(() => {
      if(this.parallax2 !== false)
        this.parallax = this.parallax + 0.02;
    }), 10;
    this.$nextTick(() => {
      //
    })

  },
  beforeDestroy() {
    //
  },
  destroyed() {
    window.removeEventListener('resize', this.sizing);
    window.removeEventListener('scroll', this.scrollBg);
    window.removeEventListener('load', this.sizing);
  }
}
</script>
